export default __webpack_public_path__ + "355b95ea33ef4333f9a77c880132d93b.png";